var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pt-3",attrs:{"height":"100%","rounded":"false"}},[_vm._l((_vm.selectedExplicitActivities),function(activity){return _c('Activity',{key:activity.key,attrs:{"activity":activity,"selected":true}})}),(
      _vm.selectedExplicitActivities === null ||
      _vm.selectedExplicitActivities.length === 0
    )?_c('div'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }